import styled from 'styled-components';

interface ISquare {
  amountLines: number;
  amountColumns: number;
  selecting: boolean;
}

export const Letter = styled.p`
  font-size: 1.6rem;
  font-weight: bold;
  color: ${({ theme }) => theme.text};
  margin: 0;
  padding: 0;
  text-align: center;

  &:hover {
    filter: brightness(1.2);
    transform: scale(1.15);
  }

  @media (max-width: 900px) {
    font-size: 1.5rem;
  }
`;

export const Square = styled.div<ISquare>`
  width: calc(100% / ${(props) => props.amountLines});
  height: calc(100% / ${(props) => props.amountColumns});
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  cursor: crosshair;
  border: 1px solid ${({ theme }) => theme.purple};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  border: 3px solid;
  border-image-slice: 1;
  border-width: 3px;
  border-image-source: linear-gradient(${({ theme }) => theme.borderWordle});
  padding: 4px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;
`;
